import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getTodaySellTractorBumpStatus,
  IReturnTodaySellTractorBumpStatus,
} from '../../../../api/product/queries/getTodaySellTractorBumpStatus';

export const useGetTodaySellTractorBumpStatus = () => {
  return useQuery<IReturnTodaySellTractorBumpStatus, AxiosError>(
    ['today-sell-tractor-bump-status'],
    getTodaySellTractorBumpStatus,
  );
};
